import { type Html, html, View } from 'rune-ts';
import klass from './ProductSection.module.scss';
import { font, staticFont } from '@services/MarppleShop/shared/typography';

export class ProductSection extends View<{ is_mobile: boolean }> {
  override template(): Html {
    return html`
      <section class="${klass.container}">
        <div class="${klass.title_wrapper}">
          <div class="${staticFont('bebas_20_bold')} ${klass.chapter}">CHAPTER 2.</div>
          <div class="${font('48_bold', '28_bold')} ${klass.title}">
            까다롭고 혼자서 만들기 힘든<br />굿즈 제작도 문제 없어요
          </div>
        </div>
        <div class="${klass.content_wrapper} ${font('20_medium', '14_medium')}">
          마플샵과 함께라면 1,400종 이상의 상품을 제작할 수 있어요
        </div>
        <div class="${klass.product_list}">
          <div class="${klass.marquee_wrapper}">
            <div class="${klass.marquee_background}">
              <img
                src="//s3.marpple.co/files/u_29089/2025/11/original/ae4c7cbb2fcea3d4a47535e125f6fd42d598156a1.webp"
                alt=""
              />
            </div>
            <div class="${klass.marquee_background}" aria-hidden="true">
              <img
                src="//s3.marpple.co/files/u_29089/2025/11/original/ae4c7cbb2fcea3d4a47535e125f6fd42d598156a1.webp"
                alt=""
              />
            </div>
            <div class="${klass.marquee_background}" aria-hidden="true">
              <img
                src="//s3.marpple.co/files/u_29089/2025/11/original/ae4c7cbb2fcea3d4a47535e125f6fd42d598156a1.webp"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
    `;
  }
}
